/**
 * 请求拦截器：处理请求的url api前缀
 *
 * @since 1.0.0
 * @version 1.0.0
 */

import { deepCopy } from 'utils/index'
import { IS_DEV } from '@/utils/node-env'

const REPLACE_REG = /(:([^/]*))/g

/**
 * 替换urls中的变量
 *
 * @param {string} source - url请求
 * @param {object} [variable] - 要替换变量处的数据
 * @returns {string} - 返回替换变量后新的url请求
 */
const replaceVariable = function replaceVariable(source, variable = {}) {
  return source.replace(REPLACE_REG, (matched, key) => {
    return variable[key.slice(1)]
  })
}

/**
 * 再包装用于发起http请求的选项
 *
 * @param {object} config - http 配置参数
 * @returns {object} 返回更改后的config1123
 */
export default function APIUrlReqInterceptor(config) {
  let { url, params, data } = config
  const { vars } = config
  if (!url) {
    throw new Error('please set "url" params !')
  }

  // // 替换url中的变量
  // if (url.indexOf(':') >= 0) {
  //   url = replaceVariable(url, vars)
  // }

  params = deepCopy(params)

  data = deepCopy(data)

  Object.keys(params).forEach((key) => {
    if ([undefined, null, ''].includes(params[key])) {
      delete params[key]
    }
  })

  Object.keys(data).forEach((key) => {
    if ([undefined, null, ''].includes(data[key])) {
      delete data[key]
    }
  })

  // if (!url.startsWith('http') && IS_DEV) {
  //   url = process.env.VUE_APP_API_HOST + '/api' + url
  // }

  config.url = url
  config.params = params
  config.data = data

  return config
}
